/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import teamService from '@/services/team';

const state = {
    groups: [],
    availability: {},
    latency: {},
};

const getters = {
    groups: state => state.groups,
    availability: state => group => state.availability[group],
    latency: state => group => state.latency[group],
};

const actions = {
    loadList: async ({ rootGetters, commit }) => {
        const groups = await teamService.getGroups(rootGetters['team/id']);
        console.log('loadGroups received:', groups);
        commit('addGroups', groups.data.groups);
    },
    loadAvailability: async ({ rootGetters, commit }, group) => {
        const availability = await teamService.getGroupAvailability(
            rootGetters['team/id'],
            group,
        );
        commit('addAvailability', { group, availability });
    },
    loadLatency: async ({ rootGetters, commit }, group) => {
        const latency = await teamService.getGroupLatency(
            rootGetters['team/id'],
            group,
        );
        commit('addLatency', { group, latency });
    },
};

const mutations = {
    addGroups: (state, items) => {
        state.groups = items;
    },
    addAvailability: (state, item) => {
        state.availability[item.group] = item.availability.data;
    },
    addLatency: (state, item) => {
        state.latency[item.group] = item.latency.data;
    },
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
